import { render, staticRenderFns } from "./PointsOfSalesSelector.vue?vue&type=template&id=2ac8c2a6&"
import script from "./PointsOfSalesSelector.vue?vue&type=script&lang=js&"
export * from "./PointsOfSalesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports